export const useStyles = {
  dialog(color) {
    return {
      '.MuiPaper-root': {
        background: color
      }
    }
  },

  dialogContentBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: "15px",
    paddingTop: '10px'
  },

  formControl(color, fullWidth = false, isError: false) {
    return {
      paddingTop: '10px',
      ".MuiInputBase-root": {
        fontSize: "12px",
        width: fullWidth ? "100%" : "300px",
        backgroundColor: "#F9FBFF",
        borderRadius: "4px",
        border: `1px solid ${isError ? 'red!important' : '#1B3665!important'}`,
        boxSizing: 'border-box',
        "&:hover": {
          backgroundColor: "#F9FBFF"
        },
      },
      '.MuiFormLabel-root': {
        color: `${color}!important`
      },
      '.MuiFormLabel-root.Mui-focused': {
        color: `${color}!important`
      },
      ".MuiSelect-select": {
        fontWeight: 600,
        color: color,
      },
      ".MuiTypography-root": {
        fontSize: "12px",
        color: color,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      ".MuiInputBase-root:before": {
        border: "none!important",
      },
      ".MuiInputBase-root:after": {
        border: "none!important",
      },
      "& .MuiSelect-select": {
        paddingTop: "7px",
        paddingBottom: "7px",
        borderRadius: "8px",
        lineHeight: "18px",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "& .MuiInputBase-root": {
        borderBottom: "none",
      },
    }
  },

  select: {
    '.MuiSelect-filled': {
      paddingRight: '0',
    },
  },

  menuItem: {
    fontSize: "14px",
  },

  addButton(color) {
    return {
      padding: '6px 28px',
      fontSize: '12px',
      background: color,
      width: 'fit-content',
      margin: '15px auto 10px auto',
      textTransform: 'initial'
    }
  }
};
